module.exports = __webpack_public_path__ + "img/coupon2022-sp.8c722517.jpg";